import { appRoutes } from 'routes';

export const GET_PARAMS = {
  popup: 'popup',
};

export const GET_ENUMS = {
  popup: {
    login: 'login',
    forgotPassword: 'forgot-password',
    resetPassword: 'reset-password',
    signUp: 'signup',
    emailConfirmed: 'email-confirmed',
  },
};

export const POPUP_ROUTES = ['login', 'forgot-password', 'reset-password', 'signup', 'email-confirmed'];

export const ROOT_PATHS = [appRoutes.rootPath(), appRoutes.loanOfficerPath(), appRoutes.realEstateAgentPath()];



// WEBPACK FOOTER //
// ./src/const/router.js